export const PlayGameIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <title>Play Game</title>
    <g clipPath="url(#clip0_739_99923)">
      <path
        d="M9.16667 7.64551V7.29134C8.55556 7.11079 8.05556 6.76704 7.66667 6.26009C7.27778 5.75315 7.08333 5.16634 7.08333 4.49967C7.08333 3.69412 7.36806 3.00662 7.9375 2.43717C8.50694 1.86773 9.19444 1.58301 10 1.58301C10.8056 1.58301 11.4931 1.86773 12.0625 2.43717C12.6319 3.00662 12.9167 3.69412 12.9167 4.49967C12.9167 5.16634 12.7222 5.75315 12.3333 6.26009C11.9444 6.76704 11.4444 7.11079 10.8333 7.29134V7.64551L16.6667 10.9997C16.9306 11.1525 17.1354 11.3573 17.2812 11.6143C17.4271 11.8712 17.5 12.1525 17.5 12.458V14.0413C17.5 14.3469 17.4271 14.6281 17.2812 14.8851C17.1354 15.142 16.9306 15.3469 16.6667 15.4997L10.8333 18.8538C10.5694 19.0066 10.2917 19.083 10 19.083C9.70833 19.083 9.43056 19.0066 9.16667 18.8538L3.33333 15.4997C3.06944 15.3469 2.86458 15.142 2.71875 14.8851C2.57292 14.6281 2.5 14.3469 2.5 14.0413V12.458C2.5 12.1525 2.57292 11.8712 2.71875 11.6143C2.86458 11.3573 3.06944 11.1525 3.33333 10.9997L9.16667 7.64551ZM5.66667 11.583L10 14.083L14.3333 11.583L10.8333 9.56217V12.4163H9.16667V9.56217L5.66667 11.583Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_739_99923">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.75)"
        />
      </clipPath>
    </defs>
  </svg>
);
